import React from 'react';
import { gqlSubscription } from '@minecraft.graphql-types';
import { ArtistSubscriptionFragment, SubscriptionStatusEnum } from '@minecraft.graphql-operations';
import { useTranslation } from '@blocs.i18n';
import { TextDynamic } from '@minecraft.atoms';
import { BillingCodes } from './enums/plans';

export const useSubscriptionPlanTitle = (
  subscription: gqlSubscription | ArtistSubscriptionFragment,
  withoutMembershipKeyword = false
): string | React.ReactNode => {
  const { t } = useTranslation();
  const plan = subscription?.plan;

  if (!plan) return t('common:notApplicable');

  if (!plan.billingCode) {
    return '';
  }

  const membershipKeyword = withoutMembershipKeyword ? 'withoutKeyword' : 'withKeyword';

  let translationKey = `common:planTitle.${membershipKeyword}.${plan.billingCode}`;

  if (plan.billingCode === BillingCodes.registration) {
    translationKey = `common:planTitleNew.${membershipKeyword}.${plan.billingCode}`;
  }

  const planName = t(translationKey);
  const status = t(`common:subscriptionStatus.${subscription.status}`);

  if (withoutMembershipKeyword || !subscription.status) {
    return planName;
  }

  if (subscription.status === SubscriptionStatusEnum.Paused) {
    const PausedLabel = (
      <TextDynamic
        as="span"
        fontSize="bodySmall"
        color="error"
        fontWeight="semibold"
        mdProps={{
          fontSize: 'bodyRegular',
        }}
      >
        ({status})
      </TextDynamic>
    );

    return (
      <>
        {planName} {PausedLabel}
      </>
    );
  }

  return `${planName} (${status})`;
};
